
const homepage = {
  // Hero section
  'hero.headline': 'Trading d\'Elite. Ora Accessibile a Tutti.',
  'hero.subheadline': 'Strategie di investimento professionali una volta riservate alle istituzioni — ora disponibili per gli investitori al dettaglio attraverso The Club',
  'hero.cta.join': 'Unisciti a The Club',
  'hero.cta.track': 'Segui le Nostre Performance',
  
  // What is The Club section
  'whatIs.header': 'Cos\'è The Club?',
  'whatIs.subtitle': 'Trading Professionale, Ridefinito per Te',
  'whatIs.copy': 'In The Club, stiamo rimodellando il panorama finanziario. La nostra missione è semplice: rendere accessibili le strategie di trading d\'élite a livello istituzionale agli investitori al dettaglio — con trasparenza, performance e fiducia al centro. Offrire un modello di business sostenibile e a lungo termine che permetta alle persone comuni di partecipare a quello che una volta era un mondo finanziario esclusivo. Siamo qui per democratizzare l\'accesso alla libertà finanziaria — un investitore alla volta.',
  'whatIs.cta': 'Incontra il Team di The Club',
  
  // Why Join section
  'whyJoin.header': 'Perché Unirsi a The Club?',
  'whyJoin.subtitle': 'Investimenti Intelligenti, Semplici e Potenti',
  'whyJoin.copy': 'La nostra piattaforma ti permette di far crescere la tua ricchezza con fiducia, guidato da esperti di alto livello che gestiscono il tuo portafoglio.',
  'whyJoin.feature1.title': 'Inizia con soli $500',
  'whyJoin.feature1.desc': 'Nessuna barriera, nessun limite — scala secondo i tuoi termini',
  'whyJoin.feature2.title': 'Performance Trasparente',
  'whyJoin.feature2.desc': 'Accesso in tempo reale alle metriche del tuo portafoglio',
  'whyJoin.feature3.title': 'Gestione Professionale del Rischio',
  'whyJoin.feature3.desc': 'Strategie per proteggere e far crescere il tuo capitale',
  'whyJoin.feature4.title': 'Supporto Globale',
  'whyJoin.feature4.desc': 'Il nostro team è qui — nella tua lingua, nella tua regione',
  'whyJoin.cta': 'Investi Ora',
  
  // Trusted Broker section
  'broker.header': 'Broker di Fiducia',
  'broker.subtitle': 'Il Tuo Capitale Merita una Casa Sicura',
  'broker.copy': 'Sicurezza e trasparenza contano. Ecco perché lavoriamo esclusivamente con Radex Markets, un broker regolamentato autorizzato dalla Seychelles Financial Services Authority (FSA). Radex dà priorità alla protezione del cliente implementando robusti protocolli di sicurezza per salvaguardare sia i fondi dei clienti che i dati personali. Offre tecnologia all\'avanguardia e un ambiente di trading competitivo progettato per soddisfare le esigenze dei trader moderni.',
  'broker.cta': 'Scopri di Più Sul Nostro Broker',
  'broker.badge1': 'Elaborazione Sicura',
  'broker.badge2': 'Regolamentato FSA',
  'broker.badge3': 'Sicurezza dei Fondi',
  'broker.badge4': 'Operazioni Trasparenti',
  
  // Meet Traders section
  'traders.header': 'Incontra i Nostri Trader',
  'traders.subtitle': 'Esperienza Reale. Strategie Provate.',
  'traders.copy': 'Il nostro team di trading porta oltre 16 anni di esperienza nello sviluppo di strategie algoritmiche istituzionali dal 2009. Con una profonda comprensione dei mercati globali, sanno come adattarsi e performare — indipendentemente dalle condizioni. Alcuni dei nostri professionisti sono persino stati classificati nei primi 5 nel Regno Unito su piattaforme come Pelican Asset Management. Con un focus implacabile su bassi drawdown e controllo rigoroso del rischio, ora sono accessibili per te per fornire risultati.',
  'traders.stats.experience': '16+',
  'traders.stats.experienceLabel': 'Anni di Esperienza',
  'traders.stats.rank': 'Top 5',
  'traders.stats.rankLabel': 'Classifica Trading UK',
  'traders.stats.since': 'Dal 2009',
  'traders.stats.sinceLabel': 'Sviluppo Strategie',
  'traders.approach.algorithmic.title': 'Approccio Algoritmico',
  'traders.approach.algorithmic.point1': 'Decisioni basate sui dati',
  'traders.approach.algorithmic.point2': 'Strategie backtested dal 2009',
  'traders.approach.algorithmic.point3': 'Parametri di gestione del rischio',
  'traders.approach.risk.title': 'Controllo del Rischio',
  'traders.approach.risk.point1': 'Focus su bassi drawdown',
  'traders.approach.risk.point2': 'Regole rigorose di dimensionamento delle posizioni',
  'traders.approach.risk.point3': 'Approccio adattivo al mercato',
  
  // Performance section
  'performance.header': 'Performance di The Club',
  'performance.subtitle': 'Vedi i Nostri Trader in Azione',
  'performance.recentPerformance': 'Performance Recente',
  'performance.monthlyPerformance': 'Performance Mensile',
  'performance.yearlyPerformance': 'Proiezione Annuale',
  'performance.maxDrawdown': 'Drawdown Massimo',
  'performance.winRate': 'Tasso di Vincita',
  'performance.cta': 'Segui Institutional Strategy su FX Blue',
  'performance.tagline': 'Performance di Picco. Drawdown Minimo. 100% Trasparenza.',
  'performance.myfxbooktext': 'Performance come nessun altro, convalidata attraverso FX Blue',
  'performance.institutional': 'Strategia Istituzionale',
  'performance.spartanAi': 'Spartan AI',
  'performance.ctaSpartan': 'Segui Spartan AI su Myfxbook',
  'performance.myfxbookTextSpartan': 'Performance convalidata attraverso Myfxbook',
  'performance.recentPerformanceInstitutional': 'Performance di Institutional Strategy',
  'performance.recentPerformanceSpartan': 'Performance di Spartan AI',
  'performance.strategiesCta': 'Scopri di Più Sulle Nostre Strategie',
  
  // How it works section
  'howItWorks.header': 'Come Funziona',
  'howItWorks.subtitle': 'Regole Semplici. Ricompense Chiare.',
  'howItWorks.feature1.title': 'Unisciti con soli $500',
  'howItWorks.feature1.desc': 'Inizia in piccolo, scala in qualsiasi momento — nessun limite massimo',
  'howItWorks.feature2.title': 'Nessuna Quota di Iscrizione',
  'howItWorks.feature2.desc': 'Per un periodo limitato, la tariffa del 20% è stata rimossa. Investi con TheClub e inizia a guadagnare dal primo giorno',
  'howItWorks.feature3.title': 'Incentivi Allineati',
  'howItWorks.feature3.desc': 'Una commissione di performance del 50% — vinciamo solo quando vinci tu',
  'howItWorks.feature4.title': 'Preleva in qualsiasi momento',
  'howItWorks.feature4.desc': 'Accesso completo a capitale e profitti — nessun periodo di blocco',
  'howItWorks.feature5.title': 'Metodi di Deposito e Prelievo',
  'howItWorks.feature5.desc': 'Visa, Mastercard, bonifico bancario e cripto — veloce e flessibile',
  'howItWorks.feature6.title': 'Conformità KYC e AML',
  'howItWorks.feature6.desc': 'La tua sicurezza e fiducia normativa sono le nostre priorità',
  'howItWorks.cta': 'Unisciti a The Club',
  'howItWorks.calculator.title': 'Vedi il Tuo Potenziale di Crescita Con l\'Interesse Composto',
  'howItWorks.calculator.results': 'Risultati:',
  'howItWorks.calculator.totalInvestment': 'Investimento Totale ($)',
  'howItWorks.calculator.investment': 'Investimento ($)',
  'howItWorks.calculator.membership': 'Tariffa di Iscrizione ($)',
  'howItWorks.calculator.monthlyRate': 'Tasso di Interesse Mensile (%)',
  'howItWorks.calculator.fiftymonthlyRate': '50% Tasso di Interesse Mensile (%)',
  'howItWorks.calculator.variationRate': 'Tasso di Variazione Mensile (%)',
  'howItWorks.calculator.years': 'Tempo di Investimento (Anni)',
  'howItWorks.calculator.calculate': 'Calcola',
'howItWorks.calculator.simpleInvestment': 'Valore futuro con prelievo mensile',
'howItWorks.calculator.compoundInvestment': 'Valore futuro con interesse composto',
'howItWorks.calculator.difference': 'Differenza',
  'howItWorks.calculator.monthAbbr': 'M',
  'howItWorks.calculator.yearAbbr': 'A',
  'howItWorks.calculator.month': 'Mese',
  'howItWorks.calculator.year': 'Anno',
  
  // Team section
  'team.header': 'Incontra il Nostro Team',
  'team.subtitle': 'The Club è Guidato da Visionari',
  'team.text': 'Incontra le menti che plasmano la missione di The Club e promuovono la libertà finanziaria globale attraverso trasparenza, integrità e alte performance — rendendo gli investimenti accessibili a tutti.',
  'team.member1': 'Gianluca N. – Responsabile Sviluppo \nNuovi Mercati',
  'team.member2': 'Samuel N. – Responsabile Marketing',
  'team.member3': 'Marco M. – Consulente di Intermediazione\n(Responsabile Italia \npresso Radex Markets)',
  'team.member4': 'Lloyd S. – Chief Trading Officer',
  'team.member5': 'Horacio A. – Consulente \nTecnologico Esecutivo',
  
  // Global Presence section
  'global.header': 'Presenza Globale',
  'global.subtitle': 'Volti Locali. Portata Globale.',
  'global.text': 'Che tu sia in Italia, Germania, Medio Oriente o America Latina, siamo qui con supporto locale — nella tua lingua e nel tuo fuso orario.',
  'global.contact1': 'Germano M. – Rappresentante Della Lingua Italiana',
  'global.contact2': 'Manuel G. – Rappresentante Della Lingua Tedesca',
  'global.contact3': 'Horacio A. – Rappresentante Della Lingua Spagnola',
  'global.contact4': 'Aisha R. – Rappresentante Della Lingua Inglese',
  'global.contact5': 'XXX XXXX – Rappresentante Delle Lingue Francese E Araba',
  'global.tagline': 'Vuoi far crescere la tua comunità con The Club? Parla direttamente con uno dei nostri rappresentanti.',
  
  // Referral section
  'referral.header': 'Programma Referral',
  'referral.subtitle': 'Guadagna Facendo Crescere la Tua Comunità',
  'referral.text': 'Condividi l\'Opportunità. Costruisci il Tuo Reddito.',
  'referral.copy.default': 'Come partner di The Club, non solo puoi guadagnare dai tuoi investimenti, ma anche aiutare gli altri a far crescere il loro reddito. Il nostro piano di compensazione a 10 livelli ti consente di costruire un reddito residuo a lungo termine — con pagamenti delle commissioni programmati per il 10 di ogni mese.',
  'referral.copy.alternate': 'Come partner di The Club, non solo puoi guadagnare dai tuoi investimenti, ma anche aiutare gli altri a far crescere il loro reddito. Il nostro piano di compensazione a 5 livelli ti consente di costruire un reddito residuo a lungo termine — con pagamenti delle commissioni programmati per il 10 di ogni mese.',
  'referral.table.level': 'Livello',
  'referral.table.commission': 'Commissione',
  'referral.table.levelNumber': 'Livello {level}',
  'referral.structure.title': 'Struttura dei Livelli',
  'referral.commission.title': 'Piano Compensi - Crea La Tua Rendita Passiva!',
  'referral.commission.description.default': 'Il piano di compensazione paga fino al 20% (combinato) sui primi 10 livelli di profondità basato sui profitti generati dai clienti su base mensile. Questo dà a ogni affiliato l\'opportunità di guadagnare un reddito mensile reale e crescente grazie all\'effetto dell\'interesse composto, che permette a ogni affiliato di vedere il proprio portafoglio clienti crescere nel tempo, supportato dalle alte performance delle nostre strategie di trading.',
  'referral.commission.description.alternate': 'Il piano di compensazione paga fino al 12% (combinato) sui primi 5 livelli di profondità basato sui profitti generati dai clienti su base mensile. Questo dà a ogni affiliato l\'opportunità di guadagnare un reddito mensile reale e crescente grazie all\'effetto dell\'interesse composto, che permette a ogni affiliato di vedere il proprio portafoglio clienti crescere nel tempo, supportato dalle alte performance delle nostre strategie di trading.',
  'referral.example.title': 'Scenario di Esempio',
  'referral.example.text': 'Se iscrivi 3 persone, ciascuna delle quali investe $1.000, e ciascuna delle quali ne iscrive altre 2, guadagnerai commissioni da tutte e 9 le persone della tua comunità, creando un potente flusso di reddito passivo.',
  
  // New ReferralSection keys
  'referral.you': 'Tu',
  'referral.level1Commission': 'Livello 1: 5% Commissione',
  'referral.directReferral': 'Referral Diretto',
  'referral.levels2to4Commission': 'Livelli 2-4: 3% Commissione',
  'referral.levels5to6Commission': 'Livelli 5-6: 2% Commissione ciascuno',
  'referral.level7Commission': 'Livello 7: 1%',
  'referral.level8Commission': 'Livello 8: 0,5%',
  'referral.level9Commission': 'Livello 9: 0,3%',
  'referral.level10Commission': 'Livello 10: 0,2%',
  'referral.communityExpands': 'La tua comunità si espande più in profondità, guadagnandoti commissioni fino a {maxLevels} livelli',
  'referral.earnCommissions.default': 'Il piano di compensazione si basa su una struttura UNILEVEL che paga fino a 10 livelli di profondità. La nostra struttura ti premia per costruire una comunità forte.',
  'referral.earnCommissions.alternate': 'Il piano di compensazione si basa su una struttura UNILEVEL che paga fino a 5 livelli di profondità. La nostra struttura ti premia per costruire una comunità forte.',
  'referral.levelSuffix': 'Livello',
  
  // Events section
  'events.header': 'Eventi e Comunità',
  'events.subtitle': 'Un Club che Connette',
  'events.text': 'Partecipa a webinar, incontra altri investitori e fai parte di qualcosa di più grande. Vedi cosa sta succedendo — online e di persona.',
  'events.event1': 'Eventi in Arrivo',
  'events.event2': 'Eventi in Arrivo',
  'events.event3': 'Eventi in Arrivo',
  'events.communityHighlights': 'Punti Salienti della Comunità',
  'events.weeklyStrategySessions': 'Sessioni Strategiche Settimanali',
  'events.weeklyStrategySessionsDesc': 'Unisciti ai nostri esperti nell\'analizzare le opportunità di mercato',
  'events.investorInterviews': 'Interviste agli Investitori',
  'events.investorInterviewsDesc': 'Ascolta storie di successo dalla nostra comunità in crescita',
  'events.educationalResources': 'Risorse Educative',
  'events.tradingFundamentals': 'Fondamentali del Trading',
  'events.tradingFundamentalsDesc': 'Guide gratuite per comprendere il trading',
  'events.expertWebinars': 'Webinar di Esperti',
  'events.expertWebinarsDesc': 'Argomenti avanzati per utenti esperti',
  
  // Connect section
  'connect.header': 'Rimani Connesso',
  'connect.subtitle': 'Teniamoci in Contatto',
  'connect.whatsapp': 'Contattaci via WhatsApp',
  'connect.language.english': 'English',
  'connect.language.italian': 'Italiano',
  'connect.language.spanish': 'Español',
  'connect.language.german': 'Deutsch',
  'connect.language.croatian': 'Hrvatski',
  'connect.language.turkish': 'Türkçe',
  'connect.language.french': 'Français',
  'connect.language.arabic': 'العربية',
  
  // Footer section
  'footer.rights': 'Tutti i diritti riservati.',
  'footer.terms': 'Termini di Servizio',
  'footer.privacy': 'Politica sulla Privacy',
  'footer.cookies': 'Cookies',
  'footer.contactMe': 'Contattami',
  
  // Strategies page
  // 'strategies.heroSubtitle': 'Due Strategie. Una Visione. Massima Protezione e Crescita.',
  'strategies.pageTitle': 'Strategie di TheClub',
  'strategies.heroSubtitle': 'Una Visione. Massima Protezione e Crescita.',
  'strategies.learnMore': 'Scopri di più',
  'strategies.showLess': 'Mostra meno',

  // Institutional Strategy
  'strategies.institutional.tagline': 'Precisione. Stabilità. Protezione di Livello Istituzionale.',
  'strategies.institutional.highlight1': '16 Anni di Esperienza',
  'strategies.institutional.highlight1Desc': 'Trader istituzionali britannici con esperienza in hedge fund e Deutsche Bank',
  'strategies.institutional.highlight2': 'Focus su Gold e GU',
  'strategies.institutional.highlight2Desc': 'Algoritmi a media/alta frequenza su Gold e Sterlina/Dollaro',
  'strategies.institutional.highlight3': 'Obiettivo Mensile 5–6%',
  'strategies.institutional.highlight3Desc': 'Rendimenti costanti con una media del 35–40% annuo',
  'strategies.institutional.highlight4': 'Rischio Controllato',
  'strategies.institutional.highlight4Desc': 'Approccio conservativo che privilegia la preservazione del capitale',
  'strategies.institutional.description': 'È una strategia gestita direttamente dai nostri trader istituzionali britannici, un gruppo di lavoro che opera nei mercati finanziari da 16 anni. Hanno lavorato con uno dei più importanti hedge fund del Regno Unito e con Deutsche Bank. Sono specializzati nella creazione e nell\'aggiornamento continuo di algoritmi che operano a media/alta frequenza principalmente su Gold e GU (Sterlina/Dollaro). È una strategia che mira a ottenere una media del 5–6% al mese, come già raggiunto nel primo anno con The Club, mantenendo un rischio relativamente contenuto per fornire al cliente una media di circa il 35–40% annuo.',

  // Spartan AI Strategy
  'strategies.spartanAi.tagline': 'Aggressiva. Intelligente. Performance di Livello Spartan.',
  'strategies.spartanAi.highlight1': 'Basata su AI',
  'strategies.spartanAi.highlight1Desc': 'Intelligenza artificiale continuamente aggiornata da trader italiani',
  'strategies.spartanAi.highlight2': 'Gold Intraday',
  'strategies.spartanAi.highlight2Desc': 'Strategia semi-manuale che combina operazioni AI con trade manuali',
  'strategies.spartanAi.highlight3': 'Potenziale di Profitto Superiore',
  'strategies.spartanAi.highlight3Desc': 'Approccio più aggressivo che genera rendimenti superiori',
  'strategies.spartanAi.highlight4': '20% Equity Stop',
  'strategies.spartanAi.highlight4Desc': 'Protezione massima della perdita coperta dai profitti di Institutional Strategy',
  'strategies.spartanAi.description': 'È un\'intelligenza artificiale creata e continuamente aggiornata dal nostro gruppo di trader italiani che lavorano professionalmente nel mondo del trading da 6 anni con risultati eccellenti. È una strategia più aggressiva che opera in modo semi-manuale: i trader stessi operano combinando le operazioni dell\'AI con i propri trade manuali. Opera intraday esclusivamente su Gold. È una strategia che tende a generare profitti molto più elevati ma allo stesso tempo ha un equity stop del 20%. Ciò significa che il cliente non potrà mai perdere più del 20% del capitale investito in Spartan AI; questo capitale è coperto dalla Institutional Strategy con i suoi profitti nel caso in cui, una volta all\'anno, questo equity stop venga raggiunto.',

  // Strategy Bond (50/50)
  'strategies.bond.title': 'Più Forti Insieme: L\'Approccio 50/50',
  'strategies.bond.description': 'Ogni deposito è strategicamente diviso 50/50 tra entrambe le strategie. La Institutional Strategy fornisce una base stabile e conservativa che protegge il tuo capitale, mentre Spartan AI offre un potenziale di crescita aggressivo. Nel raro caso in cui Spartan AI raggiunga il suo equity stop del 20%, i profitti costanti della Institutional Strategy fungono da rete di sicurezza — garantendo che il tuo investimento complessivo rimanga protetto e in crescita.',
  'strategies.bond.benefit1': 'Massima Protezione',
  'strategies.bond.benefit1Desc': 'I profitti di Institutional Strategy proteggono dagli equity stop di Spartan AI',
  'strategies.bond.benefit2': 'Diversificazione Intelligente',
  'strategies.bond.benefit2Desc': 'Due approcci distinti riducono il rischio complessivo del portafoglio',
  'strategies.bond.benefit3': 'Crescita Ottimizzata',
  'strategies.bond.benefit3Desc': 'Stabilità conservativa incontra potenziale di profitto aggressivo',

  // Floating button
  'floatingButton.embassador.title': 'Diventa un Ambasciatore di The Club',
  'floatingButton.embassador.text': 'Unisciti al nostro programma di referral e guadagna fantastiche commissioni aiutando gli altri a raggiungere la libertà finanziaria. Contattaci su WhatsApp per iniziare il tuo percorso come ambasciatore di The Club oggi stesso!',
  'floatingButton.embassador.button': 'Diventa un Ambasciatore di The Club',
  'floatingButton.embassador.contact': 'Connettiti con un Rappresentante',
  'floatingButton.embassador.feature1': 'Costruisci la tua community',
  'floatingButton.embassador.feature2': 'Guadagna fino a {maxLevels} livelli di commissioni',
  'floatingButton.embassador.feature3': 'Pagamenti puntuali, programmati per il 15 di ogni mese',
};

export default homepage;
